import type { LpProductRequest } from '@apis/renewal/lpProduct';

type LpCategoryRequest = Pick<
  LpProductRequest,
  'mcd' | 'ccds' | 'pcds' | 'lcds'
>;

export const getLpCategoryRequest = (
  categories: readonly string[]
): LpCategoryRequest => {
  const mcd = categories.find(code => code.toLowerCase().startsWith('m'));
  const ccd = categories.find(code => code.endsWith('000000'));
  const pcd = categories.find(
    code => !code.endsWith('000000') && code.endsWith('000')
  );
  const lcds = categories.filter(
    code => code !== mcd && code !== ccd && code !== pcd
  );

  return {
    ...(mcd ? { mcd } : {}),
    ...(ccd ? { ccds: [ccd] } : {}),
    ...(pcd ? { pcds: [pcd] } : {}),
    ...(lcds.length > 0 ? { lcds } : {}),
  };
};
